/**
 * Remap a value from one arbitrary range to another.
 * If the input range is [0, 1] you can use lerp() instead.
 */
export function remap(
	value: number,
	inputLow: number,
	inputHigh: number,
	outputLow: number = 0,
	outputHigh: number = 1,
): number {
	return outputLow + ((outputHigh - outputLow) * (value - inputLow)) / (inputHigh - inputLow)
}
